import React, { useContext } from 'react'
import useResponsiveSelector from 'hooks/useResponsiveSelector'
import GeoContext from 'contexts/geoContext'
import LuxuryEscapesSmallLogo from './LuxuryEscapesSmallLogo'
import LuxuryEscapesSmallLogoUkFlag from './LuxuryEscapesSmallLogoUkFlag'
import LuxuryEscapesLogo from './LuxuryEscapesLogo'
import LuxuryEscapesLogoUkFlag from './LuxuryEscapesLogoUkFlag'

export interface ResponsiveLogoProps {
  /** @default icon+text */
  mobileVariant?: 'icon' | 'icon+text'
  /** @default icon+text */
  tabletVariant?: 'icon' | 'icon+text'
  /** @default icon+text */
  desktopVariant?: 'icon' | 'icon+text'
}

type Props = React.SVGAttributes<SVGSVGElement> & ResponsiveLogoProps

function ResponsiveLuxuryEscapesLogo(props: Props) {
  const {
    mobileVariant = 'icon+text',
    tabletVariant = 'icon+text',
    desktopVariant = 'icon+text',
    ...rest
  } = props

  const showSmall = useResponsiveSelector({
    mobile: mobileVariant === 'icon',
    tablet: tabletVariant === 'icon',
    desktop: desktopVariant === 'icon',
  })

  const geo = useContext(GeoContext)

  return <>
    {showSmall && <>
      {geo.currentRegionCode !== 'GB' && <LuxuryEscapesSmallLogo {...rest} width={35} />}
      {geo.currentRegionCode === 'GB' && <LuxuryEscapesSmallLogoUkFlag {...rest} width={53} />}
    </>}
    {!showSmall && <>
      {geo.currentRegionCode !== 'GB' && <LuxuryEscapesLogo {...rest} />}
      {geo.currentRegionCode === 'GB' && <LuxuryEscapesLogoUkFlag {...rest} />}
    </>}
  </>
}

export default ResponsiveLuxuryEscapesLogo
